export const HoldingsConstants = {
	NUMBER_PORTFOLIOS_TO_TRIGGER_EMPTY_COL: 2,
	WEIGHT_DECIMAL: 2,
	SNAPSHOT_DATA_IDS: {
		AS_OF_DATE_END: 'commonEndDate',
		AS_OF_DATE_START: 'commonStartDate',
		TOTAL_RISK: 'totalRisk'
	},
	PERFORMANCE_COLUMNS: ['performanceReturn', 'twelveMonthTrailingYield', 'performanceDownsideUpside'],
	PERFORMANCE_COLUMNS_BENCHMARK: ['performanceReturn', 'twelveMonthTrailingYield', 'performanceDownsideUpsideBenchmark'],
	PERFORMANCE_COLUMNS_WITH_NET_CUSTOM: [
		{
			sectionKey: 'ANNUALIZED_RETURN',
			children: ['performanceReturn', 'netCustomPerformanceReturn']
		},
		'twelveMonthTrailingYield',
		{
			sectionKey: 'UPSIDE_DOWNSIDE',
			children: ['performanceDownsideUpside', 'netCustomPerformanceDownsideUpside']
		}
	],
	PERFORMANCE_COLUMNS_WITH_NET_CUSTOM_BENCHMARK: [
		{
			sectionKey: 'ANNUALIZED_RETURN',
			children: ['performanceReturn', 'netCustomPerformanceReturn']
		},
		'twelveMonthTrailingYield',
		{
			sectionKey: 'UPSIDE_DOWNSIDE_BENCHMARK',
			children: ['performanceDownsideUpsideBenchmark', 'netCustomPerformanceDownsideUpsideBenchmark']
		}
	],
	PERFORMANCE_COLUMNS_NO_NET_BENCHMARK: [
		{
			sectionKey: 'ANNUALIZED_RETURN',
			children: ['performanceReturn']
		},
		'twelveMonthTrailingYield',
		{
			sectionKey: 'UPSIDE_DOWNSIDE_BENCHMARK',
			children: ['performanceDownsideUpsideBenchmark']
		}

	],
	PERFORMANCE_COLUMNS_NO_NET: [
		{
			sectionKey: 'ANNUALIZED_RETURN',
			children: ['performanceReturn']
		},
		'twelveMonthTrailingYield',
		{
			sectionKey: 'UPSIDE_DOWNSIDE',
			children: ['performanceDownsideUpside']
		}
	]
};

export const DynamicHoldingsAnalyticsHeadings = {
	NILE_CUSTOM_BENCHMARK_UPSIDE_DOWNSIDE: 'Upside / Downside Capture vs $customBenchmark$',
	NILE_CUSTOM_BENCHMARK_UPSIDE_DOWNSIDE_1_YR: '1 Yr Upside / Downside Capture vs $customBenchmark$',
	NILE_CUSTOM_BENCHMARK_UPSIDE_DOWNSIDE_3_YR: '3 Yr Upside / Downside Capture vs $customBenchmark$',
	NILE_CUSTOM_BENCHMARK_UPSIDE_DOWNSIDE_5_YR: '5 Yr Upside / Downside Capture vs $customBenchmark$',
	NILE_CUSTOM_BENCHMARK_UPSIDE_DOWNSIDE_10_YR: '10 Yr Upside / Downside Capture vs $customBenchmark$'
};

export const DynamicHoldingsAnalyticsInfoBubbles = {
	// eslint-disable-next-line max-len
	NILE_CUSTOM_BENCHMARK_UPSIDE_DOWNSIDE_INFO_BUBBLE: 'The level of participation achieved historically in strong (rising) or weak (falling) equity markets. Source: Morningstar\n Upside Capture: The ratio of portfolio performance to the performance the $customBenchmark$, in periods where the $customBenchmark$ performance is positive. A value greater than 100% indicates the portfolio has generated better performance compared to the $customBenchmark$ when the $customBenchmark$ performance is positive.\n Downside Capture: The ratio of portfolio performance to the performance of the $customBenchmark$, in periods where the $customBenchmark$ performance is negative. A value greater than 100% indicates the portfolio has generated worse performance compared to the $customBenchmark$ when the $customBenchmark$ performance is negative.'
};

